import React from 'react';

type MoonIconProps = {
	className?: string;
	style?: React.CSSProperties;
}

// @ant-design/icons n'a pas d'icône lune : tracé Feather (MIT).
export default function MoonIcon({ className, style }: MoonIconProps) {
	return (
		<svg
			className={className}
			style={style}
			viewBox="0 0 24 24"
			width="1em"
			height="1em"
			fill="none"
			stroke="currentColor"
			strokeWidth={2}
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
		</svg>
	);
}
